import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { 
    withStyles,
    Grid,
    MenuItem,
    TextField
  } from '@material-ui/core';
import '../../../scss/component/onboarding/company_profile.scss'
import Autocomplete from '@material-ui/lab/Autocomplete';


const useStyles = (theme) => ({
    root: {
      width: '100%',
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  });

class CompanyProfileStepThree extends PureComponent{
    state={
          selectedOption: null,
    }

    dataOptions = [
        { value: 'Any personal data of children under 16', label: 'Any personal data of children under 16' },
        { value: 'Cookies', label: 'Cookies' },
        { value: 'Cultural or demographic information', label: 'Cultural or demographic information' },
        { value: 'Email Addresses', label: 'Email Addresses' },
        { value: 'Financial records', label: 'Financial records' },
        { value: 'Insurance information', label: 'Insurance information' },
        { value: 'IP Addresses', label: 'IP Addresses' },
        { value: 'Lab or test results', label: 'Lab or test results' },
        { value: 'Medical History', label: 'Medical History' },
        { value: 'Names', label: 'Names' },
        { value: 'None', label: 'None' },
        { value: 'Not Sure', label: 'Not Sure' },
        { value: 'Payment Card data', label: 'Payment Card data' },
        { value: 'Social Media Posts', label: 'Social Media Posts' },
        { value: 'SSNs or Tax ID Numbers', label: 'SSNs or Tax ID Numbers' },
        { value: 'Unlisted phone numbers', label: 'Unlisted phone numbers' },
        { value: 'Other', label: 'Other' },
    ]

    numRecordsOptions = [
        { value: '0-25,000', label: '0-25,000' },
        { value: '25,000-100,000', label: '25,000-100,000' },
        { value: '100,000 - 1,000,000', label: '100,000 - 1,000,000' },
        { value: '1,000,000+', label: '1,000,000+' },
    ]

    dataLocationOptions = [
        { value: `Your customer's location`, label: `Your customer's location` },
        { value: 'Hosted offsite (e.g. in the cloud storage/backup, data center, online application)',
         label: 'Hosted offsite (e.g. in the cloud storage/backup, data center, online application)' },
        { value: 'Onsite (e.g. office computers, servers, storage devices at your location)',
         label: 'Onsite (e.g. office computers, servers, storage devices at your location)' },
        { value: 'Mobile device (e.g. phones and tablets)', label: 'Mobile device (e.g. phones and tablets)' },
    ]

    dataAccessOptions = [
        { value: 'Access to your data', label: 'Access to your data' },
        { value: 'Access to your network', label: 'Access to your network' },
        { value: `I Don't Know`, label: `I Don't Know` },
        { value: 'No Access', label: 'No Access' },
    ]


    handleChange = selectedOption => {
        this.setState({ selectedOption });
    };

    render(){
        const { classes, 
            saveDataCollected,
            saveRecordCount,
            saveDataStorage, 
            saveAccessLevel,
            dataCollected,
            dataStorage,
            dataRecordCount,
            dataAccessLevel
             } = this.props;
        return(
            <div>
                <div id="form_title">
                    <h3>Step 3: Tell us a bit about the information you collect</h3>

                </div>
                <div className="form_container_short">
                    <form>

                        <Grid container spacing={2}>
                            <Grid item md={6}>
                                <label >Do you collect any of the following data?</label><br/>
                                <Autocomplete
                                    multiple
                                    options={this.dataOptions}
                                    getOptionLabel={(option) => option.label}
                                    defaultValue={()=>{
                                        if (dataCollected === undefined || dataCollected === ""){
                                            return []
                                        }
                                        else{
                                            const dataList = dataCollected.map((entry)=>{
                                                return({value:entry,label:entry})
                                            });
                                            return dataList
                                        }
                                    }}
                                    onChange={(event,dataList)=>{
                                        const response = dataList.map((data)=>{
                                            return data.value
                                        })
                                        saveDataCollected(response)
                                    }}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select all that apply"
                                    />
                                    )}
                                    /><br/><br/>

                                <label>How many records do you store/process?</label><br/>
                                <Autocomplete
                                    options={this.numRecordsOptions}
                                    getOptionLabel={(option) => option.label}
                                    defaultValue={()=>{
                                        if (dataRecordCount === undefined || dataRecordCount === ""){
                                            return {value:"",label:""}
                                        }
                                        else{
                                            return({value:dataRecordCount,label:dataRecordCount})
                                        }
                                    }}
                                    onChange={(event,data)=>{saveRecordCount(data.value)}}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select an option"
                                    />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <label>Where is this data stored?</label><br/>
                                <Autocomplete
                                    options={this.dataLocationOptions}
                                    getOptionLabel={(option) => option.label}
                                    defaultValue={()=>{
                                        if (dataStorage === undefined || dataStorage === ""){
                                            return {value:"",label:""}
                                        }
                                        else{
                                            return({value:dataStorage,label:dataStorage})
                                        }
                                    }}
                                    onChange={(event,data)=>{saveDataStorage(data.value)}}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select an option"
                                    />
                                    )}
                                /><br/><br/>

                                <label>What level of access do third-parties have?</label><br/>
                                <Autocomplete
                                    options={this.dataAccessOptions}
                                    getOptionLabel={(option) => option.label}
                                    defaultValue={()=>{
                                        if (dataAccessLevel === undefined || dataAccessLevel === ""){
                                            return {value:"",label:""}
                                        }
                                        else{
                                            return({value:dataAccessLevel,label:dataAccessLevel})
                                        }
                                    }}
                                    onChange={(event,data)=>{saveAccessLevel(data.value)}}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select an option"
                                    />
                                    )}
                                /><br/><br/>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        )
    }
}

export default withRouter(withApollo((withStyles(useStyles)(CompanyProfileStepThree))))


// WEBPACK FOOTER //
// ./src/components/onboarding/components/CompanyProfileStepThree.js